module.exports = __webpack_public_path__ + "img/startVR.ce2cb09c.svg";